import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.$style.SidePageLayout
  }, [_c(_setup.SimpleOverlay, {
    attrs: {
      "id": "side-page-overlay"
    },
    on: {
      "clicked": _setup.handleClose
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.$style.body, _defineProperty(_defineProperty({}, _vm.$style.bodyWhite, _vm.theme === 'white'), _vm.$style.bodyNarrow, _vm.narrow)],
    attrs: {
      "id": "side-page-body"
    }
  }, [_c(_setup.SButton, {
    class: [_vm.$style.closeButton, _defineProperty({}, _vm.$style.closeButtonNarrow, _vm.narrow), _vm.closeButtonClass],
    attrs: {
      "id": "side-page-close",
      "equal": "",
      "size": "small",
      "theme": "white"
    },
    on: {
      "click": _setup.handleClose
    }
  }, [_c(_setup.SIcon, {
    attrs: {
      "icon": "i-close",
      "size": "24"
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "scrollAreaEl",
    class: [_vm.$style.wrapper, _vm.wrapperClass],
    attrs: {
      "data-scroll-area": _vm.scrollArea ? '' : undefined
    }
  }, [_vm.pending ? _c('div', {
    class: _vm.$style.loadingWrapper
  }, [_c(_setup.SLoader, {
    attrs: {
      "size": "100"
    }
  })], 1) : _vm.error ? _c('div', {
    class: _vm.$style.loadingWrapper
  }, [_c(_setup.ErrorOutput)], 1) : _c(_setup.VFadeTransition, {
    attrs: {
      "mode": "out-in",
      "appear": ""
    }
  }, [_vm._t("default")], 2)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };